module.exports = __webpack_public_path__ + "df07efb407967efff91705062bb74b4e.svg";